export default{
  items: [],
  itemsLogs: [],
  services: [],
  idUser: '',
  countPages: 0,
  current_page: 0,
  page_size: 15,
  totalElements: 0,
  totalPages: 0,
  email: '',
  search_message: '',
  loadingClear: false,
  logsToEdit: {
    channelType: '',
    dateAdded: '',
    list: '',
    message: '',
    messageType: '',
    moeCampaignName: '',
    name: '',
    produtoSlug: null,
    pushType: null,
    requestJson: '',
    responseJson: '',
    sendTime: null,
    smsContent: '',
    title: '', // email
    url: null
  },
  to: '',
  from: '',
  pagination: {
    current_page: 0,
    number_of_elements: 0,
    total_elements: 0,
    total_pages: 0
  },
}


// WEBPACK FOOTER //
// ./src/store/modules/logs/state.js